import { Copy as DuplicateIcon } from 'lucide-react'

export interface RowActionsProps {
  onDuplicate: () => void
  onDelete: () => void
  duplicateLabel?: string
  deleteLabel?: string
}

// The Duplicate/Delete cell of every list table's actions column: an
// icon + text Duplicate and a red text-link Delete. What each click does
// (open the duplicate modal, open the delete confirm) stays with the
// caller. PRD 14.
export function RowActions({
  onDuplicate,
  onDelete,
  duplicateLabel = 'Duplicate',
  deleteLabel = 'Delete',
}: RowActionsProps) {
  return (
    <div className="flex items-center justify-end gap-3">
      <button
        type="button"
        onClick={onDuplicate}
        className="inline-flex items-center gap-1 text-meta text-text-secondary hover:text-text-primary"
      >
        <DuplicateIcon size={14} strokeWidth={1.5} />
        {duplicateLabel}
      </button>
      <button
        type="button"
        onClick={onDelete}
        className="text-meta font-medium text-danger hover:underline"
      >
        {deleteLabel}
      </button>
    </div>
  )
}
